import { call, fork, put, takeEvery } from 'redux-saga/effects';

import * as Actions from '../store/notifications/actions';
import * as Types from '../store/notifications/types';
import { getAccNotifications } from '../services/ElasticApi';
import { errorToast } from './commonGenerators/errorToast';

const { ActionTypes } = Types;

function* getNotifications(): any {
    try {
        const { data } = yield call(getAccNotifications);
        yield put(Actions.UpdateAccountNotificaitons(data));
    } catch (e) {
        yield call(errorToast, e);
    }
}

function* getNotificationsWatcher(): any {
    yield takeEvery(ActionTypes.GET_ACC_NOTIFICATIONS, getNotifications);
}

const notificationSagas = [fork(getNotificationsWatcher)];

export default notificationSagas;
